import { render, staticRenderFns } from "./NuevoCaso.vue?vue&type=template&id=aef14e96&scoped=true&"
import script from "./NuevoCaso.vue?vue&type=script&lang=js&"
export * from "./NuevoCaso.vue?vue&type=script&lang=js&"
import style0 from "./NuevoCaso.vue?vue&type=style&index=0&id=aef14e96&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef14e96",
  null
  
)

export default component.exports